import { useSectionStates } from '@/features/kyc/hooks/useSectionStates';
import { IUser } from '@/features/user/store/user.model';

import { SelfVerificationDetail } from '@/features/kyc/components/userInformation/selfEmployedUser/SelfVerificationDetail';
import { SelfMainInformation } from '@/features/kyc/components/userInformation/selfEmployedUser/SelfMainInformation';
import { TSelfSectionKey } from '@/features/kyc/store/types/self.types';

export function SelfEmployedUser({ user }: { user: IUser }) {
  const { toogleSectionEditMode, isSectionEditable, isSectionOnEdition } = useSectionStates<TSelfSectionKey>([
    'mainInformation',
    'address',
    'contact',
    'birthAndNationality',
    'situation',
    'taxResidence',
  ]);

  return (
    <>
      <SelfMainInformation
        user={user}
        isSectionOnEdition={isSectionOnEdition}
        isSectionEditable={isSectionEditable}
        toogleSectionEditMode={toogleSectionEditMode}
      />
      <SelfVerificationDetail
        user={user}
        isSectionOnEdition={isSectionOnEdition}
        isSectionEditable={isSectionEditable}
        toogleSectionEditMode={toogleSectionEditMode}
      />
    </>
  );
}
